/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppDownloadModel from "./AppDownloadModel";
import "./AppDownload.scss";

export default function AppDownload () {
    const vm = new AppDownloadModel();
    return (
        <a
            href={vm.defaultUrl}
            className={vm.downloadAnchorName}
            id={vm.downloadAnchorName}
        >
        </a>
    );
}